<button
  style="height: 34px"
  matRipple
  (click)="onClick.emit()"
  class="hover:bg-gray-100 hover:text-gray-800 group flex items-center rounded-md bg-white text-gray-600 text-sm font-medium px-4 py-2"
>
  <ng-content></ng-content>
</button>
